import { Backdrop, Box } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import AddIcon from "@material-ui/icons/Add";
import { useSimpleModalToggle } from "components/dialogs/useSimpleModal";
import React from "react";
import { FormWithRedirect, useMutation, useNotify, useRefresh, useTranslate } from "react-admin";
import { useNotifyError } from "utils/notifiers/useNotifyError";

import { AddEditProductArticleFieldBody } from "./AddEditProductArticleFieldBody";

export const AddProductArticle = ({
	companyId,
	createButton = null,
	isNeedRefresh = true,
	onCreated = null,
	...props
}) => {
	const refresh = useRefresh();
	const notify = useNotify();
	const notifyError = useNotifyError();
	const translate = useTranslate();
	const { open, handleOpen, handleClose } = useSimpleModalToggle();

	const [create, { loading }] = useMutation(
		{
			type: "create",
			resource: "product-articles",
		},
		{
			onSuccess: (response) => {
				handleClose();
				if (isNeedRefresh) {
					refresh();
				}
				if (onCreated) {
					onCreated();
				}
				notify(translate("osfc.dialogs.product-articles.add.success"), "success");
			},
			onFailure: (error) => {
				notifyError(error);
			},
		}
	);

	const handleSubmit = (values) => {
		create({
			payload: {
				data: {
					...values,
					company_id: companyId,
				},
			},
		});
	};

	const renderButton = () => {
		if (createButton) {
			return React.cloneElement(createButton, { onClick: handleOpen });
		}

		return (
			<Button
				aria-label="create"
				size="small"
				color="primary"
				startIcon={<AddIcon />}
				onClick={handleOpen}
			>
				{translate("resources.product-articles.create-button")}
			</Button>
		);
	};

	return (
		<>
			{renderButton()}
			{open && (
				<Dialog open={true} maxWidth="md" onClose={handleClose}>
					<DialogTitle>{translate("resources.product-articles.create.title")}</DialogTitle>
					<Box position="relative">
						<FormWithRedirect
							record={{}}
							submitOnEnter={false}
							component={DialogContent}
							save={handleSubmit}
							render={({ handleSubmitWithRedirect, form, record }) => (
								<React.Fragment>
									<AddEditProductArticleFieldBody form={form} />
									<DialogActions>
										<Button disabled={loading} onClick={handleClose} color="primary">
											{translate("ra.action.cancel")}
										</Button>
										<Button disabled={loading} onClick={handleSubmitWithRedirect} color="primary">
											{translate("ra.action.add")}
										</Button>
									</DialogActions>
								</React.Fragment>
							)}
						/>
						<Backdrop
							open={loading}
							style={{
								position: "absolute",
								zIndex: 1000,
								backgroundColor: "rgba(255, 255, 255, 0.7)",
							}}
						>
							<CircularProgress />
						</Backdrop>
					</Box>
				</Dialog>
			)}
		</>
	);
};
